import React from 'react';
import '../../tailwind.css';

export const ThemeWrapper = ({ children }) => <React.Fragment>{children}</React.Fragment>;
